import { css } from '@compiled/react';
import React from 'react';

import { token } from '@atlaskit/tokens';
import Spinner from '@atlaskit/spinner/spinner';

import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

const spinnerContainerStyles = css({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	height: '32px',
	width: '32px',
	marginRight: token('space.150'),
});

const LoadingSpinner = () => (
	<div css={spinnerContainerStyles}>
		<Spinner interactionName="presentation-mode-lazy-buttons" />
	</div>
);

export const LazyNavigation: LoadableType<{
	contentRendered: boolean;
	spaceKey: string;
	contentId: string;
}> = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-Navigation" */ './Navigation.tsx'))
			.NavigationPresenterMode,
	loading: () => <LoadingSpinner />,
});

export const LazySettingsMenu: LoadableType<{
	onSwitchCursorClick: (boolean: any) => void;
	spaceKey: string;
	contentId: string;
}> = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-SettingsMenu" */ './SettingsMenu.tsx'))
			.SettingsMenu,
	loading: () => <LoadingSpinner />,
});
